import React from 'react'
import { FaLinkedin, FaGithub, FaEnvelope, FaPhone } from 'react-icons/fa'
import './Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const socialLinks = [
    {
      icon: <FaLinkedin />,
      url: 'https://www.linkedin.com/in/fouad-aladhami/',
      label: 'LinkedIn'
    },
    {
      icon: <FaGithub />,
      url: 'https://github.com/fouad1233',
      label: 'GitHub'
    },
    {
      icon: <FaEnvelope />,
      url: 'mailto:fouadiadhami@gmail.com',
      label: 'Email'
    }
    // ,
    // {
    //   icon: <FaPhone />,
    //   url: 'tel:+905382899184',
    //   label: 'Phone'
    // }
  ]

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Fouad Aladhami</h3>
            <p>Embedded Software Engineer specializing in Battery Management Systems and STM32 development.</p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/portfolio">Portfolio</a></li>
              <li><a href="/blog">Blog</a></li>
              <li><a href="/tools">Tools</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Connect With Me</h4>
            <div className="social-links">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={link.label}
                >
                  {link.icon}
                </a>
              ))}
            </div>
            {/* <div className="contact-info">
              <p>📧 fouadiadhami@gmail.com</p>
              <p>📱 +90 538 289 9184</p>
            </div> */}
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Fouad Aladhami. All rights reserved.</p>
          <p>Built with React & ❤️</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
